import { buildPostLogoutRedirectUri, sanitizeKeycloakAuthUrl } from '../../utils/keycloakAuthUrl';

/**
 * Собирает безопасный `post_logout_redirect_uri` для keycloak-js logout.
 *
 * @param {string} [redirectUri] - явный URI после выхода
 * @returns {string} абсолютный URL без OAuth hash
 */
export function resolvePostLogoutRedirectUri(redirectUri?: string): string {
  if (typeof redirectUri === 'string' && redirectUri !== '') {
    return sanitizeKeycloakAuthUrl(redirectUri);
  }

  const appOrigin = import.meta.env.VITE_APP_URL || window.location.origin;
  return buildPostLogoutRedirectUri(appOrigin, new URLSearchParams(window.location.search));
}
